export default __webpack_public_path__ + "static/media/check-mark.a3444d38.svg";